/**
 * Maps API notification document to the normalized client row shape
 * shared by NotificationBell and My Work notifications table.
 *
 * Title/body are stored already rendered from the bound NotificationTemplate.
 *
 * @param {object} n
 * @returns {object}
 */
export function mapNotificationRow(n) {
    const data = n.data || {};
    const params = data.i18n?.params && typeof data.i18n.params === 'object' && !Array.isArray(data.i18n.params)
        ? data.i18n.params
        : {};
    return {
        id: n._id || n.id,
        title: n.title,
        message: n.message || n.body,
        type: n.type,
        eventName: data.i18n?.key || n.eventName || '',
        isRead: n.read ?? n.isRead ?? false,
        timestamp: n.createdAt || n.timestamp,
        actionUrl: n.actionUrl,
        data,
        params: {
            ...params,
            i18n: data.i18n,
            pageKey: data.pageKey,
            entityId: data.entityId,
            category: data.category,
            navigationKind: data.navigationKind,
            tab: data.tab,
            linkedEntityIds: data.linkedEntityIds,
        },
    };
}

/**
 * @param {Array<object>} rows
 * @returns {Array<object>}
 */
export function mapNotificationRows(rows) {
    return (rows || []).map(mapNotificationRow);
}
